import React from 'react';
import { HearingElement } from './HearingElement';

const HearingElementGrid = ({ onHearingClick, hearingItems }) => {
  const onClick = (hearingItem) => {
    onHearingClick && onHearingClick(hearingItem);
  };

  const hearingElements =
    hearingItems &&
    hearingItems.map((item, i) => {
      return <HearingElement onClick={onClick} hearingItem={item} key={i} />;
    });

  return <div className="changeHearingOwner-list-grid">{hearingElements}</div>;
};

export { HearingElementGrid };
